module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('CommonsHeader'), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loadingShow
    }
  }), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('CommonsBottom'), _vm._v(" "), _c('ContractPopup'), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": 2000,
      "width": _vm.toastWidth,
      "is-show-mask": "",
      "text": _vm.toastMsg,
      "position": "middle"
    },
    on: {
      "on-hide": _vm.onHide
    },
    model: {
      value: (_vm.returnToastShow),
      callback: function($$v) {
        _vm.returnToastShow = $$v
      },
      expression: "returnToastShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c408a76"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 550
// module chunks = 88